import MetricProperty from '@enums/MetricProperty';
import isPercentageMetric from './isPercentageMetric';

const PERCENT_OPTIONS = { style: 'percent', maximumFractionDigits: 2 };

/**
 * Intl.NumberFormat options for a change value. A relative change always reads
 * as a percent. An absolute change uses the metric's own format (hours/FTE
 * decimal, budget/cost currency, count integer), except percentage metrics
 * whose absolute change is a percentage-point difference and so still reads as
 * a percent.
 *
 * @param { string } metric
 * @param { boolean } [absolute]
 *
 * @return { Object }
 */
export default function getChangeFormatOptions(metric, absolute = false) {
  if (!absolute || isPercentageMetric(metric)) {
    return PERCENT_OPTIONS;
  }

  return MetricProperty[metric]?.formatOptions ?? {};
}
